import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography
} from '@mui/material'
import Button from '@mui/material/Button'
import * as React from 'react'
import { FC } from 'react'
import styled from 'styled-components'
import { Icon, iconIdList } from '../components/icon'
import { DRAWER_WIDTH } from '../config/theme'


const IconGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
`


/**
 * Component library
 * 
 * @type any
 */
export const StyleGuide: FC = () => {
  const [age, setAge] = React.useState('')

  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value)
  }

  return (
      <>
          <Grid
            sx={{
              p: 3,
              width: { sm: `calc(100% - ${DRAWER_WIDTH})` },
              margin: 'auto',
              paddingTop: 6,
              paddingBottom: 6,
            }}
              direction='column'
              justifyContent='center'
              maxWidth={640}
              spacing={4}
          >
            <Grid item>
              <Typography variant='h4' gutterBottom>
                Typography
              </Typography>
              <Typography variant='h1' gutterBottom>
                Heading 1
              </Typography>
              <Typography variant='h2' gutterBottom>
                Heading 2
              </Typography>
              <Typography variant='h3' gutterBottom>
                Heading 3
              </Typography>
              <Typography variant='h4' gutterBottom>
                Heading 4
              </Typography>
              <Typography variant='h5' gutterBottom>
                Heading 5
              </Typography>
              <Typography variant='h6' gutterBottom>
                Heading 6
              </Typography>
              <Typography variant='body1' gutterBottom>
                body1. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Quos blanditiis tenetur unde suscipit, quam beatae rerum
                inventore consectetur, neque doloribus, cupiditate numquam
                dignissimos laborum fugiat deleniti? Eum quasi quidem quibusdam.
              </Typography>
              <Typography variant='body2' gutterBottom>
                body2. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                Quos blanditiis tenetur unde suscipit, quam beatae rerum
                inventore consectetur, neque doloribus, cupiditate numquam
                dignissimos laborum fugiat deleniti? Eum quasi quidem quibusdam.
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant='h4' gutterBottom>
                Buttons
              </Typography>
              <Stack spacing={2} direction='row' alignItems='center'>
                <Button variant='contained' color='secondary'>
                  Primary
                </Button>
                <Button variant='text' color='secondary'>
                  Text
                </Button>
              </Stack>
            </Grid>
            <Grid item>
              <Typography variant='h4' gutterBottom>
                Form elements
              </Typography>
              <FormControl fullWidth margin='normal'>
                <FormLabel id='filled-basic'>Text input</FormLabel>
                <TextField id='outlined' variant='outlined' hiddenLabel />
              </FormControl>
              <FormControl fullWidth>
                <Select
                  labelId='demo-simple-select-label'
                  id='demo-simple-select'
                  value={age}
                  displayEmpty
                  onChange={handleChange}
                  inputProps={{ 'aria-label': 'Select' }}
                >
                  <MenuItem value='' disabled>
                    Select input
                  </MenuItem>
                  <MenuItem value={10}>Ten</MenuItem>
                  <MenuItem value={20}>Twenty</MenuItem>
                  <MenuItem value={30}>Thirty</MenuItem>
                </Select>
              </FormControl>
              <FormGroup>
                <FormLabel sx={{ mt: '2rem' }} id='demo-checkbox-label'>
                  Labels
                </FormLabel>
                <FormControlLabel
                  control={<Checkbox defaultChecked />}
                  label='Label'
                />
                <FormControlLabel
                  disabled
                  control={<Checkbox />}
                  label='Disabled'
                />
              </FormGroup>
              <FormControl>
                <FormLabel
                  sx={{ mt: '2rem' }}
                  id='demo-radio-buttons-group-label'
                >
                  Gender
                </FormLabel>
                <RadioGroup
                  aria-labelledby='demo-radio-buttons-group-label'
                  defaultValue='female'
                  name='radio-buttons-group'
                >
                  <FormControlLabel
                    value='female'
                    control={<Radio />}
                    label='Female'
                  />
                  <FormControlLabel
                    value='male'
                    control={<Radio />}
                    label='Male'
                  />
                  <FormControlLabel
                    value='other'
                    control={<Radio />}
                    label='Other'
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item>
              <Typography variant='h4' gutterBottom>
                Icons
              </Typography>
              <IconGrid>
                {iconIdList.map((iconId) => {
                  return <Icon key={iconId} iconId={iconId} size='size-24' />
                })}
              </IconGrid>
            </Grid>
          </Grid>
      </>
  )
}
